export default __webpack_public_path__ + "static/media/FacebookClone4.d2518b42.png";